import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'react-feather';

// Replaces the previous breadcrumb + page-title combo. Renders nothing on
// top-level pages; renders a compact "Back to <parent>" button on sub-pages
// where `childrenObj` carries the parent route.
//
// Props (kept compatible with existing call sites):
//   childrenObj: [{ name, url }, ...]   ← if present, the LAST entry is the
//                                         immediate parent.
//   parent, title, internal: ignored — kept so legacy callers don't break.
export default function PageNav({ childrenObj }) {
  const parent = Array.isArray(childrenObj) && childrenObj.length > 0
    ? childrenObj[childrenObj.length - 1]
    : null;

  if (!parent || !parent.url) return null;

  return (
    <div className='mb-3 mt-1'>
      <Link
        to={parent.url}
        className='d-inline-flex align-items-center text-decoration-none'
        style={{
          background: '#ffffff',
          border: '1px solid #e9ecef',
          borderRadius: 999,
          color: '#495057',
          fontSize: 13,
          fontWeight: 500,
          padding: '6px 14px 6px 10px',
          gap: 6,
          transition: 'all 120ms ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.borderColor = '#0d6efd';
          e.currentTarget.style.color = '#0d6efd';
          e.currentTarget.style.background = '#e7f1ff';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.borderColor = '#e9ecef';
          e.currentTarget.style.color = '#495057';
          e.currentTarget.style.background = '#ffffff';
        }}
      >
        <ArrowLeft size={14} />
        <span>Back to {parent.name}</span>
      </Link>
    </div>
  );
}
